import { QueryFunctionContext } from '@tanstack/react-query';

import { ProductSearchService } from 'src/services/ProductSearchService';

export const QUERY_KEY = 'productVersions';

export const queryProductVersions = (
    context: QueryFunctionContext<App.ProductSearch.ProductVersionsQueryKey>,
): Promise<MCP.Products.ProductSearch.Models.ProductVersionsResponse> => {
    const { queryKey } = context;
    const [, accessToken, search] = queryKey;
    const { page, limit, productKey } = search;

    return ProductSearchService.getProductVersions(
        accessToken,
        productKey,
        page,
        limit,
    );
};
